<template>
<div>
  <b-card>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="scorecardResults" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'scorecardResults',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [{
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }, {
        field:'dealer_zone_id',
        modal:'zones-modal',
        foreign: 'id',
        placeholder: 'Zona'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      }, {
        api: 'zones/lst',
        field: 'dealer_zone_id'
      }],
      url: 'scorecard/results',
      columns: [{
        field: 'ym',
        title: 'Ano/Mês',
        width: '120px'
      },
      {
        field: 'spreads',
        title: 'Spreads',
        width: '120px',
        values: lists.yesNo
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '220px'
      },
      {
        field: 'dealer_zone_id',
        title: 'Zona',
        width: '120px',
        values: []
      },
      {
        field: 'sellout1',
        title: 'Sellout Top10',
        width: '160px'
      },
      {
        field: 'sellout1ok',
        title: 'Cumpre',
        width: '160px',
        values: lists.yesNo
      },
      {
        field: 'sellout2',
        title: 'Sellout Total',
        width: '160px'
      },
      {
        field: 'sellout2ok',
        title: 'Cumpre',
        width: '160px',
        values: lists.yesNo
      },
      {
        field: 'sellout3prize',
        title: 'Prémio Sellout',
        width: '160px'
      },
      {
        field: 'sellin1',
        title: 'Sellin Top10',
        width: '160px'
      },
      {
        field: 'sellin1ok',
        title: 'Cumpre',
        width: '160px',
        values: lists.yesNo
      },
      {
        field: 'sellin2',
        title: 'Sellin Total',
        width: '160px'
      },
      {
        field: 'sellin2ok',
        title: 'Cumpre',
        width: '160px',
        values: lists.yesNo
      },
      {
        field: 'sellin3prize',
        title: 'Prémio Sellin',
        width: '160px'
      },
      {
        field: 'operators1',
        title: 'Operadores',
        width: '160px'
      },
      {
        field: 'operators1ok',
        title: 'Cumpre',
        width: '160px',
        values: lists.yesNo
      },
      {
        field: 'operators1prize',
        title: 'Prémio',
        width: '160px'
      },
      {
        field: 'operators2',
        title: 'SumTop10',
        width: '160px'
      },
      {
        field: 'operators2ok',
        title: 'Cumpre',
        width: '160px',
        values: lists.yesNo
      },
      {
        field: 'operators2prize',
        title: 'Prémio',
        width: '160px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  }
}
</script>
